module.exports = __webpack_public_path__ + "static/img/20240426_3.d77eaed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20240426_3.png
// module id = f9rb
// module chunks = 0